import script from "./MFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./MFilters.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__